import { GridFilterModel } from '@mui/x-data-grid-premium'
import { coerceStatusFilterClause } from '@omnea-app/packages/universal/requests/coerceStatusFilterClause'

export const normaliseRequestFilterModel = (filterModel: GridFilterModel): GridFilterModel => ({
  ...filterModel,
  items: filterModel.items.map((item) => {
    const coerced = coerceStatusFilterClause(item)
    return coerced ? { ...item, ...coerced } : item
  }),
})
